import { useEffect, useState } from 'react';

/**
 * FRONT-719 — force a re-render on a 1-second cadence while `active`, so a
 * client-computed elapsed timer (Date.now() - startedAt) ticks smoothly on its
 * own instead of only advancing when a network poll happens to re-render the
 * component. No backend involved — the clock is local. Stops ticking when
 * `active` goes false (e.g. the run reaches a terminal state).
 */
export function useSecondTicker(active: boolean): void {
  const [, setTick] = useState(0);
  useEffect(() => {
    if (!active) return;
    const id = setInterval(() => setTick((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, [active]);
}
